import { useCallback, useState } from "react";
import { performLogout } from "../utils/logout";

type UseLogoutOptions = {
    /** When true, expose confirm modal state instead of logging out immediately. */
    confirm?: boolean;
};

/**
 * Shared logout flow for LogoutButton and SidebarAccountMenu.
 */
export function useLogout({ confirm = false }: UseLogoutOptions = {}) {
    const [showConfirm, setShowConfirm] = useState(false);

    const doLogout = useCallback(async () => {
        setShowConfirm(false);
        await performLogout();
    }, []);

    const requestLogout = useCallback(() => {
        if (confirm) {
            setShowConfirm(true);
        } else {
            void doLogout();
        }
    }, [confirm, doLogout]);

    const closeConfirm = useCallback(() => {
        setShowConfirm(false);
    }, []);

    return {
        showConfirm,
        requestLogout,
        doLogout,
        closeConfirm,
    };
}
